<template>
  <Bar
    v-if="Array.isArray(chartData.datasets)"
    :data="chartData"
    :options="chartOptions"
  />
</template>

<script>
// https://vue-chartjs.org/examples/
import { Bar } from 'vue-chartjs'
import { Colors } from 'chart.js'
import { detailedTablePlugin } from './plugins/detailedTablePlugin.js'
import { groupedLegendPlugin } from './plugins/groupedLegendPlugin.js'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { mapGetters } from 'vuex'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors,
  detailedTablePlugin,
  groupedLegendPlugin
)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    uniqid: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: false,
      default: 'scalar'
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const chart = context.chart
                const datasets = chart.data.datasets

                // On regroupe les datasets par leur "label" (même label => base et compare)
                const currentLabel = context.dataset.label
                const currentStack = context.dataset.stack
                const currentIndex = context.dataIndex

                // Trouver le dataset jumeau (base <-> compare)
                const pairedStack = currentStack === 'base' ? 'compare' : 'base'
                const pairedDataset = datasets.find(
                  (d) => d.label === currentLabel && d.stack === pairedStack
                )

                // Récupère les valeurs
                const baseValue =
                  currentStack === 'base'
                    ? context.parsed.y
                    : (pairedDataset?.data?.[currentIndex] ?? null)

                const compareValue =
                  currentStack === 'compare'
                    ? context.parsed.y
                    : (pairedDataset?.data?.[currentIndex] ?? null)

                // Affiche uniquement une fois (évite les doublons)
                if (currentStack === 'compare') return null

                if (this.dataType === 'currency') {
                  return `${currentLabel} : ${this.$h.formatCurrency(compareValue ?? 0, this.currency)} | ${this.$h.formatCurrency(baseValue ?? 0, this.currency)}`
                }
                // Retourne une ligne "label : base | compare"
                return `${currentLabel} : ${compareValue ?? 0} | ${baseValue ?? 0}`
              },
              // Nettoie les lignes vides (retour null)
              afterBody: function (tooltipItems) {
                tooltipItems = tooltipItems.filter(Boolean)
              }
            }
          },
          htmlLegend: false,
          detailedTablePlugin: {
            containerID: this.uniqid,
            router: this.$router,
            mode: 'paired',
            stacks: ['base', 'compare']
          }
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currency: 'metadata/getDefaultCurrencyMetadata'
    })
  }
}
</script>
